







































import Vue from "vue";
import {
  defineComponent,
  ref,
  onMounted,
  toRefs,
  watch,
  computed,
} from "@vue/composition-api";

import { Campo } from "@/shared/models";
import useValores from "@/shared/composition/useValores";
import useContenido from "./useContenido";
import campoVue from "./campo.vue";
import useListaContenidos from "./useListaContenidos";

export default defineComponent({
  props: {
    titulo: String,
    get: Object,
    post: Object,
    campos: Object as () => Array<Campo>,
    query: Object,
  },
  components: {
    Campo: campoVue,
  },
  setup(props, { emit }) {
    const { query, get, post, campos } = toRefs(props);
    const divs = ref();
    const model = ref({});
    const form = ref();

    const {
      cargar: cargarData,
      cargando: deshabilitado,
      error,
      data,
    } = useContenido(get);

    const {
      cargar: guardarArray,
      cargando: guardando,
      lastError,
      finalizar
    } = useListaContenidos(post);

    const getValor = (campo: Campo) => {
      const { getValor } = useValores(model.value);
      return campo.valor || getValor(campo.path || campo.nombre);
    };

    const actualizar = (campo: Campo, event) => {
      model.value = { ...model.value, [campo.nombre]: event };
    };

    const cargar = async () => {
      await cargarData(query.value);

      model.value = { ...data.value, ...query.value };

      // Solución a valores por defectos no asignados a model.value
      // Verificar mejor implementación
      for (const campo of campos.value) {
        const valor = getValor(campo);
        actualizar(campo, valor);
      }
    };

    onMounted(cargar);

    watch([get, query], () => {
      console.log("watch actualizado, recargando");
      cargar();
    });

    const guardar = () => {
      divs.value.forEach((div) => {
        div.desenfocar();
      });

      Vue.nextTick(async () => {
        const validar = form.value.validate();

        if (!validar) {
          console.error("Form inválida");
          return;
        }

        await guardarArray(model.value);

        // *** Validar que no haya error en useListaContenidos antes de emitir cerrar
        if (!lastError.value) {
          console.log("finalizando guardar")
          finalizar()
          emit("cerrar");
        }     
      });
    };

    return {
      model,
      divs,
      guardar,
      deshabilitado,
      error,
      getValor,
      actualizar,
      data,
      lastError,
      guardando,
      form,
    };
  },
});
